import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '@services/events.service';
import {ModalComponent} from '@components/modal/modal.component';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
})
export class ConfirmComponent implements OnInit {
    public options: ConfirmOptions;

    private defaultOptions: ConfirmOptions = {
        title: 'Вы уверены, что хотите подтвердить свое действие?',
        message: 'Отменить действие будет невозможно',
        confirmButtonTitle: 'Подтвердить',
        cancelButtonTitle: 'Отмена'
    };

    @ViewChild(ModalComponent) private modal: ModalComponent;

    constructor(
        private eventsService: EventsService,
        private cd: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.setOptions();
        this.eventsService.confirmShow$.pipe().subscribe((options: ConfirmOptions) => {
            this.setOptions(options || {});
            this.modal.open();
        });
    }

    private setOptions(options?: ConfirmOptions) {
        this.options = Object.assign({}, this.defaultOptions, options || {});
    }

    confirm() {
        this.eventsService._confirmed$.next(true);
        this.modal.close();
    }

    onModalClose() {
        this.eventsService._confirmed$.next(false);
    }
}

export interface ConfirmOptions {
    title?: string;
    message?: string;
    confirmButtonTitle?: string;
    cancelButtonTitle?: string;
}
